import { AutomatedTextGetters } from './partials/automatedTextTemplate'
import { DocketwiseSettingsGetters } from './partials/docketwise'
import { EngagementLetterGetters } from './partials/engagementLetter'
import { GenericModelSettingsGetters } from './partials/genericModel'
import { InvoicedSettingsGetters } from './partials/invoiced'
import { LegalCasePartySliderSettingsGetters } from './partials/legalCasePartySlider'
import { LegalCasesSettingsGetters } from './partials/legalCases'
import { MiscSettingsGetters } from './partials/misc'
import { MultifactorAuthenticationSettingsGetters } from './partials/multifactorAuthentication'
import { OtherDocketEntriesSettingsGetters } from './partials/otherDocketEntries'
import { RecordsSettingsGetters } from './partials/records'
import { SettingsSharedGetters } from './partials/shared'
import { TimezoneSettingsGetters } from './partials/timezone'
import { TmetricSettingsGetters } from './partials/tmetric'
import { TwilioSettingsGetters } from './partials/twilio'
import { UserAccessSettingsGetters } from './partials/usersAccess'
import { UserSettingsGetters } from './partials/user'
import { WorkflowSettingsGetters } from './partials/workflows'

export const SettingsGetters = {
  ...AutomatedTextGetters,
  ...DocketwiseSettingsGetters,
  ...EngagementLetterGetters,
  ...GenericModelSettingsGetters,
  ...InvoicedSettingsGetters,
  ...LegalCasePartySliderSettingsGetters,
  ...LegalCasesSettingsGetters,
  ...MiscSettingsGetters,
  ...MultifactorAuthenticationSettingsGetters,
  ...OtherDocketEntriesSettingsGetters,
  ...RecordsSettingsGetters,
  ...SettingsSharedGetters,
  ...TimezoneSettingsGetters,
  ...TmetricSettingsGetters,
  ...TwilioSettingsGetters,
  ...UserAccessSettingsGetters,
  ...UserSettingsGetters,
  ...WorkflowSettingsGetters,
}
